/* eslint-disable @typescript-eslint/naming-convention */

export const LAYOUT_ITEM_TYPE = {
    singleSelectVertical: 'Single Select--Vertical',
    singleSelectHorizon: 'Single Select--Horizontal',
    multiSelectVertical: 'Multi-Select--Vertical',
    multiSelectHorizon: 'Multi-Select--Horizontal',
    textAria: 'Free Text',
    inputText: 'Free Text - Single Row Visible',
    dateTimePicker: 'DateTime Picker',
    email: 'Email',
    phone: 'Phone',
    datePicker: 'Date Picker',
    timePicker: 'Time Picker',
    dropdownMenu: 'Dropdown Menu',
    attachment: 'Attachment',
    starRating: 'Star Rating',
    ratingScales: 'Rating Scales',
    numberic: 'Number',
    promoterScales: 'Promoter Scales',
    descriptionQuestion: 'Description Question',
    termAndConditions: 'Terms And Conditions',
    yesNo: 'Yes No',
    iconRating: 'Icon Rating',
    tags: 'Tags',
    numberFormat: 'Number Format',
    matrix: 'Matrix',
    singleSelectQuiz: 'Single Select Quiz',
    multiSelectQuiz: 'Multi Select Quiz',
    cascadingDropdown: 'Dropdown Cascading',
};

/**
 * @deprecated APP_TOKEN is deprecated. Upload-related tokens are no longer needed
 * as the new upload API uses the main authentication token from SurveyForceStoreService.
 */
export const APP_TOKEN = {
    // All upload-related tokens have been removed for security reasons.
    // The new upload API uses the main auth token from SurveyForceStoreService.getToken()
};

export const APP_PATH = {
    SURVEY_API: 'base-platform/crm/survey-force/v1',
    SURVEY_FORCE: 'survey-force',
    START: 'start',
    ERROR: 'error',
    RESULT: 'result',
    RESULT_POPUP: 'success-popup',
    RESULT_SUCCESS: 'success',
    RESULT_FAILED: 'fail',
    RESULT_FAILED_POPUP: 'fail-popup',
    ERROR_404: '404',
    ERROR_400: '400',
    ERROR_400_POPUP: '400-popup',
    ERROR_500: '500',
    SURVEY_FORCE_EMBEDDED: 'survey-force-embedded',
    SURVEY_FORCE_POPUP: 'survey-force-popup',
    APPROVE: 'approve',
    INFO_FORMS: 'info-forms',
    WEB_COMPONENT: 'web-component',
    SURVEY_FORCE_QUIZ: 'quiz',
    RESULT_QUIZ: 'success-quiz',
    RESULT_QUIZ_THANKYOU: 'success-quiz/thank-you',
    RESULT_QUIZ_WEB_EMBEDDED: 'success-quiz/web-embedded',
    LOGIN: 'login',
    REMOTE_CONFIG: 'remote-config/:appId/:secretKey',
};

export const SELECT_OTHER_SIGN = {
    PREFIX: 'other: ',
    SEPERATE: '//',
};

export const Thank_You_Type = {
    Default: 'default_thank_you_page',
    Web_Embedded: 'web_embedded',
    Summary: 'result_summary',
};
